 
import { useMemo } from "react"
 
import { getTimeGroupData } from "../util/getTimeGroupData"
import { getGroupedSummaryData  } from "../util/getSummaryData"
 
 
export type UseConfiguredDataTypesProps = 'inline' | 'timeGroups' | 'grouped' | 'raw' | string
export interface UseConfiguredDataProps {
  data_type: UseConfiguredDataTypesProps
}

export const useConfiguredData = (
  data_type = 'inline' as UseConfiguredDataTypesProps, 
  options?: Record<string, unknown>
): { processed_data?: Record<string, unknown>[], data?: Record<string, unknown>[] } | undefined => {
 
  const {
   
    color_key,
    data,
    time_group,
    timestamp_key,
    axis_settings,
    grouping_key,
    totals_key,
    value_keys,
    count_key,
 
  } = options || {}

 
  const totals_key_to_use = totals_key || axis_settings?.left?.key || axis_settings?.right?.key
   const value_keys_to_use = value_keys || axis_settings?.left?.keys || axis_settings?.right?.keys

  const data_to_use = useMemo(() => {
    if (!data) return 
    
    let processed_data = data as typeof data
    const chart_data = processed_data as typeof data

    if (data_type === 'inline') { 
      
      if (time_group) {
        const [ time_grouped_data ] = getTimeGroupData(
          data as Record<string, unknown>[],
          {
            timestamp_key,
            time_group,
            flatten: true
          }
        )

        const time_grouped_summary_data = getGroupedSummaryData(
          time_grouped_data,
          {
            grouping_key: ['time_group', grouping_key].filter(Boolean),
            color_key,
            count_key,
            flatten: true,
            value_keys: value_keys_to_use,
            totals_key: totals_key_to_use
          }
        )
 
        processed_data = time_grouped_data
        return { data: time_grouped_summary_data, processed_data }
      }
    }
    
    
    return { data: chart_data, processed_data }

  }, [ data, data_type, time_group, timestamp_key])
  
   return data_to_use 
}